/* eslint-disable @typescript-eslint/ban-types */
/**
 *  ===============================================================================================
 *     ____ _____ _   _          _______     __                 _____           _     _    _
 *    |  _ \_   _| \ | |   /\   |  __ \ \   / /                / ____|         | |   | |  | |
 *    | |_) || | |  \| |  /  \  | |__) \ \_/ /__  _ __   ___  | |  __ _ __ ___ | |__ | |__| |
 *    |  _ < | | | . ` | / /\ \ |  _  / \   / _ \| '_ \ / _ \ | | |_ | '_ ` _ \| '_ \|  __  |
 *    | |_) || |_| |\  |/ ____ \| | \ \  | | (_) | | | |  __/ | |__| | | | | | | |_) | |  | |
 *    |____/_____|_| \_/_/    \_\_|  \_\ |_|\___/|_| |_|\___|  \_____|_| |_| |_|_.__/|_|  |_|
 *
 *  ===============================================================================================
 * @author    BINARY one GmbH
 * @license Unlicensed
 */
import '/src/scss/index.scss';
//in your `main.js` file
import { BASEURL, SITEURL } from '@libTs/cms.globals';

import {createApp} from 'vue';

import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';

// Component imports
import ZeugnisGenerator from "./components/ZeugnisGenerator.vue";
import ZeugnisUebersicht from "./components/ZeugnisUebersicht.vue";
import VorlageText from "./components/VorlageText.vue";
import Dropdown from "./components/Dropdown.vue";
import FunktionenDropdown from "./components/FunktionenDropdown.vue";
import Einleittext from './components/Einleittext.vue';
import Abschlusstext from './components/Abschlusstext.vue';

// Directive imports

// Service imports

// -----------------------------------------------------------
// DEBUG output
const ISDEBUG = import.meta.env.DEV;

if (ISDEBUG) {
  console.group('Environment loaded');
  console.log(ISDEBUG);
  console.log(
    ' -----------------------------------\n',
    ` BASEURL:\t\t${BASEURL}\n`,
    ` SITEURL:\t\t${SITEURL}\n`,
    '-----------------------------------'
  );
  console.groupEnd();
}

const app = createApp({
  setup(){
  },
  data() {
    return {
    };
  },
  provide() {
    return {
    };
  },
  components: {
    ZeugnisGenerator,
    ZeugnisUebersicht,
    VorlageText,
    Einleittext,
    QuillEditor,
    Abschlusstext,
    Dropdown,
    FunktionenDropdown,
  },
  directives: {

  }
});

app.mount('#app');
